module.exports = __webpack_public_path__ + "img/171-galapagos-islands.fc163a44.svg";